import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
  oneData: null,
};

export const khajurahoPackageSlice = createSlice({
  name: 'khajurahoPackage',
  initialState,
  reducers: {
    getPackages: (state) => {
      state.loading = true;
    },
    getOnePackage: (state) => {
      state.loading = true;
    },
    successPackage: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    successOnePackage: (state, action) => {
      state.loading = false;
      state.oneData = action.payload;
    },
    failedPackage: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  },
});

export const { 
  getPackages, 
  getOnePackage, 
  successPackage, 
  successOnePackage,
  failedPackage 
} = khajurahoPackageSlice.actions;

export default khajurahoPackageSlice.reducer;
